<template>
  <div class="white-bg mt-40" v-loading="loading">
    <div class="flex flex-v-center flex-h-bet">
      <h2 class="text-gray bold mt-40 mb-40">{{ approverData.group_name }}</h2>
      <div class="btn-wrapper mb-10 mr-20 move-right">
        <router-link
          to="/admin/attendance/overtime/settings/approver"
          class="btn-back"
        >
          <span>Back</span>
        </router-link>
      </div>
    </div>

    <h3 class="bold mb-20">Approvers List</h3>
    <div class="small-cards">
      <div>
        <p>Approvers Count</p>
        <p class="bold mt-10">{{ approverData.approvers_count }}</p>
      </div>
      <div>
        <p>Approval Type</p>
        <p class="bold mt-10">{{ approverData.approval_types }}</p>
      </div>
    </div>

    <div>
      <div
        v-for="(item, i) in approverData.approvalLevels"
        :key="item.id"
        class="small-cards"
      >
        <div>
          <p>Approver {{ i + 1 }}</p>
          <p class="bold mt-10">
            {{ approverData.approvalLevels[i]["approval_person_name"] }}
          </p>
        </div>
        <div>
          <p>Alt Approver {{ i + 1 }}</p>
          <p class="mt-10 bold mb-20">
            {{ approverData.approvalLevels[i]["alt_approval_person"] }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapActions } = createNamespacedHelpers("admin/attendance/overtime");

export default {
  data() {
    return {
      loading: false,
      approverData: [],
    };
  },
  mounted() {
    const id = this.$route.params.id;
    if (id) {
      this.fetchApprover(id);
    }
  },
  methods: {
    ...mapActions(["getApproverById"]),
    fetchApprover(id) {
      this.loading = true;
      this.$store
        .dispatch("admin/attendance/overtime/getApproverById", id)
        .then(response => {
          this.loading = false;
          this.approverData = response.data;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
